import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, useMotionValue, useTransform, animate, AnimatePresence } from 'framer-motion';
import { FiShoppingCart, FiActivity, FiBarChart2, FiTrendingUp, FiArrowRight, FiSettings, FiDollarSign, FiClock } from 'react-icons/fi';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import CandlestickChart from '../components/CandlestickChart';
import { io } from "socket.io-client";
import axios from 'axios';
import { BASE_API_URL } from '../helpers/Config';
import toast from 'react-hot-toast';
import moment from 'moment';
import { TriggerBalanceUpdate } from '../helpers/TriggerBalanceUpdate';
import { IoDiamond } from "react-icons/io5";

const TradeScreen = () => {
    const FetchMyTrades = async () => {
        try {
            const response = await axios.post(`${BASE_API_URL}/trade/my-trades`, {
                token: localStorage.getItem('a5srf4wer7w1cd'),
                entity_id: 'bitcoin',
                period: '30s'
            });
            const data = response?.data;
            console.log(data);

        } catch (error) {
            console.error('Error fetching trades:', error);
            toast.error('Failed to fetch coin data', { position: 'bottom-center' });
        }
    };

    useEffect(() => {
        FetchMyTrades();
    }, [])



    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="d-flex flex-column"
            style={{
                paddingBottom: '80px',
                minHeight: '100vh'
            }}
        >

        </motion.div>
    );
};

export default TradeScreen;